var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('WebCam',{ref:"webcam",attrs:{"deviceId":_vm.deviceId,"width":"auto","height":"100%","isFrontCam":_vm.frontCam},on:{"notSupported":_vm.notsupported}})}
var staticRenderFns = []

export { render, staticRenderFns }